import { render, staticRenderFns } from "./intantTaskDetail.vue?vue&type=template&id=684bf7bc"
import script from "./intantTaskDetail.vue?vue&type=script&lang=js"
export * from "./intantTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./intantTaskDetail.vue?vue&type=style&index=0&id=684bf7bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports